import { Outlet } from 'react-router-dom'

import { Auth, User } from 'Components/Layout'
import { Lazy } from 'Components/Loader'

import Password from 'Components/FormGroup/Password'

const user = [
    {
        path: 'user',
        element: <Auth guard="user" />,
        children: [
            { path: 'verify-email', element: <Lazy view="Auth/VerifyEmail" /> },
            { path: 'verify-email/:id/:hash', element: <Lazy view="Auth/VerifyEmail" /> },
        ],
    },
    {
        path: 'user',
        element: <User guard="user" />,
        children: [
            { path: '', element: <Lazy view="User/Dashboard" /> },
            { path: 'profile', element: <Lazy view="User/Dashboard/Profile" /> },
            { path: 'password', element: <Password /> },

            {
                path: 'roles',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Roles/List" /> },
                    { path: 'create', element: <Lazy view="User/Roles/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Roles/Create" title="Edit" /> },
                ],
            },
            {
                path: 'users',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Users/List" /> },
                    { path: 'create', element: <Lazy view="User/Users/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Users/Create" title="Edit" /> },
                ],
            },
            {
                path: 'customers',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Customers/List" /> },
                    { path: 'create', element: <Lazy view="User/Customers/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Customers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'service-staffs',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/ServiceStaffs/List" /> },
                    { path: 'create', element: <Lazy view="User/ServiceStaffs/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/ServiceStaffs/Create" title="Edit" /> },
                ],
            },
            {
                path: 'stores',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Stores/List" /> },
                    { path: 'create', element: <Lazy view="User/Stores/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Stores/Create" title="Edit" /> },
                ],
            },
            { path: 'order-requests', element: <Lazy view="User/OrderRequests/List" /> },
            {
                path: 'orders',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Orders/List" /> },
                    { path: 'create', element: <Lazy view="User/Orders/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Orders/Create" title="Edit" /> },
                    { path: ':id', element: <Lazy view="User/Orders/View" title="View" /> },
                ],
            },
            { path: 'order-progress', element: <Lazy view="User/OrderProgress/List" /> },
            {
                path: 'warranty-services',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/WarrantyServices/List" /> },
                    { path: ':id', element: <Lazy view="User/WarrantyServices/View" title="View" /> },
                ],
            },
            {
                path: 'customer-requests',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/CustomerRequests/List" /> },
                    { path: ':id', element: <Lazy view="User/CustomerRequests/View" title="View" /> },
                ],
            },
            { path: 'wallets', element: <Lazy view="User/Wallets/List" /> },
            {
                path: 'withdrawal-requests',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/WithdrawalRequests/List" /> },
                    { path: ':id', element: <Lazy view="User/WithdrawalRequests/View" title="View" /> },
                ],
            },
            {
                path: 'machine-types',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/MachineTypes/List" /> },
                    { path: 'create', element: <Lazy view="User/MachineTypes/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/MachineTypes/Create" title="Edit" /> },
                ],
            },
            {
                path: 'machines',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Machines/List" /> },
                    { path: 'create', element: <Lazy view="User/Machines/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Machines/Create" title="Edit" /> },
                ],
            },
            {
                path: 'terms',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Terms/List" /> },
                    { path: 'create', element: <Lazy view="User/Terms/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Terms/Create" title="Edit" /> },
                ],
            },
            {
                path: 'festival-offers',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/FestivalOffers/List" /> },
                    { path: 'create', element: <Lazy view="User/FestivalOffers/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/FestivalOffers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'service-inspections',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/ServiceInspection/List" /> },
                    { path: 'create', element: <Lazy view="User/ServiceInspection/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/ServiceInspection/Create" title="Edit" /> },
                ],
            },
            {
                path: 'machine-demos',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/MachineDemo/List" /> },
                    { path: 'create', element: <Lazy view="User/MachineDemo/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/MachineDemo/Create" title="Edit" /> },
                ],
            },
        ],
    },
]

export default user
